import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  trigger: {
    '& path': {
      fill: "".concat(palette.shades[500])
    },
    '&:hover': {
      '& path': {
        fill: "".concat(palette.shades[700])
      }
    }
  },
  addNew: {
    display: 'flex',
    minHeight: '56px',
    '& .MuiAutocomplete-root': {
      width: '100%'
    },
    '& .MuiInputBase-input': {
      padding: '0 !important'
    },
    '& .MuiInputBase-root': {
      minHeight: '56px',
      paddingTop: '10px',
      paddingLeft: '12px',
      alignItems: 'center'
    }
  },
  tagChip: {
    display: 'flex',
    position: 'relative',
    margin: '0 5px 5px 0'
  },
  tagChipAction: {
    width: '24px',
    height: '24px',
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '2px 0 0 2px'
  },
  tagChipTitle: {
    height: '24px',
    margin: '0 1px',
    padding: '0 6px',
    fontSize: '15px',
    fontWeight: '700',
    lineHeight: '24px'
  },
  tagChipDelete: {
    width: '24px',
    height: '24px',
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0 2px 2px 0'
  },
  colors: {
    zIndex: 1,
    top: '32px',
    left: '1px',
    display: 'flex',
    padding: '6px 8px',
    position: 'absolute',
    backgroundColor: "".concat(palette.shades[100]),
    border: "1px solid ".concat(palette.shades[500]),
    '&:after': {
      top: '-5px',
      left: '6px',
      width: '8px',
      height: '8px',
      content: "''",
      display: 'block',
      position: 'absolute',
      transform: 'rotateZ(45deg)',
      backgroundColor: "".concat(palette.shades[100]),
      borderTop: "1px solid ".concat(palette.shades[500]),
      borderLeft: "1px solid ".concat(palette.shades[500])
    }
  },
  color: {
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginLeft: '-1px',
    border: "1px solid ".concat(palette.shades[500])
  }
});
export default useStyles;